<template>
  <VDialog
    class="file-confirmation-dialog"
    width="400px"
		not-hide-on-click
  >
    <template #header>
			<div class="title">
				{{ title }}
			</div>
			<div class="description">
				{{ description }}
			</div>
		</template>

    <ul class="file-list">
      <li
          class="file-item"
          v-for="(item, key) in uploadFiles"
          :key="key"
      >
				<img
					class="icon"
					:src="getFileIcon(item)"
					:alt="item.name"
				/>

        <div class="name">
          <div :title="item.name">
						{{ item.name }}
					</div>
          <div class="size">
						{{ Utils.file.formatSize(item.size) }}
					</div>
        </div>
      </li>
    </ul>

    <template #footer>
      <VButton
        theme="primary"
        @click="approve"
      >
        Загрузить
      </VButton>

      <VButton
				@click="cancel"
      >
				Отмена
			</VButton>
    </template>
  </VDialog>
</template>

<style lang="scss" src="./VFileUploadConfirmationDialog.scss"/>

<script>

import EntityPointer from '@/domains/EntityPointer/EntityPointer';
import Utils         from '@/core/utils/Utils';
import FileUtils 						 from "@/core/utils/FileUtils";
import anyIcon 							 from '@/assets/images/file.svg'
import FilesService from "@/core/services/Files/FilesService";

export default defineComponent({
  name: 'VFilesUploadConfirmationDialog',

  props: {
    /** Файлы, которые хотим загрузить к какой-то сущности */
    uploadFiles: {
      type: Array,
    },
    /** То, к какой сущности файлы будем прикреплять */
		targetEntity: {
			type: [EntityPointer, Object],
			required: true,
		}
  },

  data() {
    return {
      Utils
    }
  },

  computed: {
		title() {
			return `Загрузить ${this.uploadFiles.length} файл(ов)`
		},

		description() {
			return `Для “${this.targetEntity.name}”`
		}
	},

	mounted() {
		FilesService.lockDragDrop();
	},

	beforeUnmount() {
		FilesService.unlockDragDrop();
	},


	methods: {
    approve() {
      this.$emit('approve');
			this.$emit('close');
    },
    cancel() {
      this.$emit('cancel');
			this.$emit('close');
    },

		getFileIcon(file) {
			const ext = file.name?.split('.').pop()?.toLowerCase();
			return FileUtils.ICONS_MAP[ext] || anyIcon;
		}
  }
})

</script>
